import { useAtom } from '@xstate/store/react';

import {
	activatePendingContent,
	audioPlayerState,
	clearPendingContent,
	closeAudioPlayer,
	openAudioPlayer,
	setActiveFeature,
	setActiveMenu,
	setCustomization,
	setIsPaused,
	setIsPlaying,
	updatePlayerState,
} from '../state/AudioPlayerState';

export const useAudioPlayerStore = () => {
	const state = useAtom(audioPlayerState);

	return {
		// State
		isOpen: state.isOpen,
		isPlaying: state.isPlaying,
		isPaused: state.isPaused,
		activeContent: state.activeContent,
		activeFeature: state.activeFeature,
		activeMenu: state.activeMenu,
		pendingContent: state.pendingContent,
		cloudId: state.cloudId,
		customization: state.customization,

		// Actions
		openAudioPlayer,
		closeAudioPlayer,
		activatePendingContent,
		clearPendingContent,
		setIsPlaying,
		setIsPaused,
		updatePlayerState,
		setActiveFeature,
		setActiveMenu,
		setCustomization,
	};
};
